import { useCallback, useEffect, useState } from 'react';
import { isUpdateAvailable, skipWaitingSW, SW_UPDATE_EVENT } from '../installServiceWorker';
export default function useSWUpdate() {
    const [updateAvailable, setUpdateAvailable] = useState(isUpdateAvailable);
    useEffect(() => {
        const handler = () => setUpdateAvailable(true);
        window.addEventListener(SW_UPDATE_EVENT, handler);
        return () => window.removeEventListener(SW_UPDATE_EVENT, handler);
    }, []);
    const acceptUpdate = useCallback(() => {
        skipWaitingSW();
    }, []);
    const dismiss = useCallback(() => {
        setUpdateAvailable(false);
    }, []);
    return { updateAvailable, acceptUpdate, dismiss };
}
